export const CLIENT_JUSSUB_NOT_FOUND = "CLIENT_JUSSUB_NOT_FOUND";

export const JUSSUB_PROVIDER = "jussub";

export function isJusSubNotFoundResponse(data) {
  return data?.code === CLIENT_JUSSUB_NOT_FOUND;
}

export function shouldUsePlanOffers(offers) {
  return Array.isArray(offers) && offers.length > 0;
}

/**
 * Converte o payload de GET /subscription/plans/offers/:client_id
 * para o formato usado no combobox de planos do admin.
 */
export function mapOffersToAdminPlans(data = []) {
  if (!Array.isArray(data)) {
    return [];
  }

  const plans = [];

  for (const group of data) {
    const groupCycleDays = group?.cycleDays;
    const groupOffers = group?.offers;

    if (!Array.isArray(groupOffers)) {
      continue;
    }

    for (const offer of groupOffers) {
      const plan = offer?.plan;
      if (!plan?.id) {
        continue;
      }

      plans.push({
        id: plan.id,
        name: plan.name,
        amount: plan.amount,
        periodicity: plan.cycleDays ?? groupCycleDays,
        offerType: offer.offerType,
        externalId: plan.externalId
      });
    }
  }

  return plans.filter(
    (plan, index, self) => index === self.findIndex(p => p.id === plan.id)
  );
}
